export default __webpack_public_path__ + "0c1e71f8002447be24364596c0492526.jpg";